import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/kshAdmin/Control/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/kshAdmin/Control/create",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.get("/kshAdmin/Control/edit",{
        params: {id:params}
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/kshAdmin/Control/createPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/kshAdmin/Control/editPost",{...params} )
}



function DELE(params) {
    return  axios.get("/kshAdmin/Control/delete",{
        params: {
            ids:params
        }
    } )
}

function CHANG_STATUS_PROXY(params) {
    return  axios.post("/kshAdmin/Control/userDisplayEdit",{user_displays:params} )
}
export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    DELE,CHANG_STATUS_PROXY
}
